import { useEffect, useCallback } from 'react';
import { useLocation } from 'react-router-dom';

const COOKIE_CONSENT_KEY = 'cookie_consent';
const API_URL = process.env.REACT_APP_BACKEND_URL;

/**
 * GoogleAnalytics - Loads Google Analytics gtag.js
 * ONLY when user has accepted ALL cookies (marketing: true).
 * Tracks SPA route changes via useLocation.
 */
const GoogleAnalytics = () => {
  const location = useLocation();

  const loadGA = useCallback((gaId) => {
    if (!gaId || window.gtag) return;

    // Load gtag.js script
    const script = document.createElement('script');
    script.async = true;
    script.src = `https://www.googletagmanager.com/gtag/js?id=${gaId}`;
    document.head.appendChild(script);

    // Initialize gtag
    window.dataLayer = window.dataLayer || [];
    window.gtag = function() { window.dataLayer.push(arguments); };
    window.gtag('js', new Date());
    window.gtag('config', gaId, {
      send_page_view: true,
      cookie_flags: 'SameSite=None;Secure',
    });
  }, []);

  // Initial load: check consent and load GA
  useEffect(() => {
    const consentStr = localStorage.getItem(COOKIE_CONSENT_KEY);
    if (!consentStr) return;

    try {
      const consent = JSON.parse(consentStr);
      if (!consent.marketing) return;
    } catch {
      return;
    }

    fetch(`${API_URL}/api/settings`)
      .then(r => r.json())
      .then(data => {
        if (data.googleAnalyticsId) {
          loadGA(data.googleAnalyticsId);
        }
      })
      .catch(() => {});
  }, [loadGA]);

  // Track SPA route changes
  useEffect(() => {
    if (window.gtag) {
      window.gtag('event', 'page_view', {
        page_path: location.pathname + location.search,
        page_title: document.title,
      });
    }
  }, [location]);

  return null;
};

export default GoogleAnalytics;
